import {getSizes, IconProps} from "@/base/components/icon/IconBase";

export const RSSFilledIcon = (props: IconProps) => {
	const [width, height] = getSizes(props.width, props.height, 28, 28);
	return <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} style={props.style || {}} viewBox="0 0 448 512" fill="none" className={`text-primary ${props.className || ''}`}>
		<path
			fill={'currentColor'}
			d="M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM96 136c0-13.3 10.7-24 24-24c137 0 248 111 248 248c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-110.5-89.5-200-200-200c-13.3 0-24-10.7-24-24zm0 96c0-13.3 10.7-24 24-24c83.9 0 152 68.1 152 152c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-57.4-46.6-104-104-104c-13.3 0-24-10.7-24-24zm0 120a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"/>
		{props.children}
	</svg>
}